module.exports = __webpack_public_path__ + "img/7_194.1d8ffa4c.png";